var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2823 2.95396C20.5169 2.99307 20.6734 3.11039 20.8298 3.26683C20.9471 3.46237 21.0254 3.65792 21.0254 3.85346C21.0254 7.13861 20.2041 10.1891 18.5615 13.0049C16.9189 15.7426 14.7679 17.9327 12.0303 19.5361C9.21446 21.1787 6.16396 22 2.87881 22C2.64416 22 2.44861 21.9609 2.29218 21.8045C2.09663 21.6871 1.97931 21.4916 1.97931 21.2569L1.04069 17.1896C0.962476 16.9941 1.00158 16.7985 1.11891 16.5639C1.19713 16.3683 1.35356 16.2119 1.58822 16.1337L5.96842 14.2564C6.12485 14.1782 6.3204 14.1782 6.55505 14.2173C6.7506 14.2564 6.90703 14.3738 7.06347 14.5302L8.9798 16.8767C10.5051 16.1728 11.8739 15.2342 13.0471 14.0218C14.2204 12.8485 15.1981 11.4797 15.9021 9.95445L13.5555 7.99901C13.3991 7.88168 13.2818 7.72525 13.2427 7.5297C13.1645 7.33416 13.2036 7.13861 13.2818 6.90396L15.159 2.52376C15.2372 2.36732 15.3546 2.21089 15.5892 2.09356C15.7848 2.01534 15.9803 1.97623 16.215 2.01534L20.2823 2.95396Z",
    stroke: "#DFE5EF",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon_phone.3f5a529cfa8d3440283890680eee37b5.svg";
export { ForwardRef as ReactComponent };